import type { PatientCareTask, PatientCareTaskType } from './usePatientCareTasks'

export type CareTaskTab = 'all' | 'open' | 'completed'
export type CareTaskOrder = 'newest' | 'oldest'

export type CareTaskFilters = {
  tab: CareTaskTab
  search: string
  type: PatientCareTaskType | null
  status: string | null
  order: CareTaskOrder
}

export const TASK_TYPE_LABELS: Record<PatientCareTaskType, string> = {
  'progress-note': 'Progress note',
  'lab-result': 'Lab result',
  fax: 'Fax',
  letter: 'Letter',
  manual: 'Manual',
}

const inTab = (task: PatientCareTask, tab: CareTaskTab) =>
  tab === 'all' || (tab === 'open' ? task.isOpen : !task.isOpen)

/** Tab counts, before any search or filter narrows the list. */
export function countByTab(tasks: PatientCareTask[]): Record<CareTaskTab, number> {
  const open = tasks.filter((t) => t.isOpen).length
  return { all: tasks.length, open, completed: tasks.length - open }
}

/** The tasks the list shows. The server sends them newest first. */
export function filterCareTasks(
  tasks: PatientCareTask[],
  filters: CareTaskFilters,
): PatientCareTask[] {
  const search = filters.search.trim().toLowerCase()
  const shown = tasks.filter(
    (task) =>
      inTab(task, filters.tab) &&
      (!filters.type || task.type === filters.type) &&
      (!filters.status || task.status === filters.status) &&
      (!search || task.item.name.toLowerCase().includes(search)),
  )
  return filters.order === 'oldest' ? shown.reverse() : shown
}
